import React, { FC } from 'react'
import { useCoreLocaleText } from '@moonpig/web-core-locale-text'
import {
  QuantitySelector,
  createProductQuantitySelectorSelectContentGAEvent,
} from '@moonpig/web-shared-products'
import { trackGAEvent } from '@moonpig/web-core-analytics'
import { ProductModuleSection } from '../ProductModuleSection'
import { useProductContext } from '../../../contexts/product'
import { ProductModule } from '../types'
import { ProductDetailsStateActionTypes } from '../../../contexts/product/types'

const MAX_GIFT_QUANTITY = 10

export const QuantitySelectorModule: FC<ProductModule> = props => {
  const [
    {
      product: { id, customisable, masterVariant },
      selectedOptions: { quantity },
    },
    dispatch,
  ] = useProductContext()

  const localiseText = useCoreLocaleText()

  const shouldShowGiftQuantitySelector = !customisable

  return shouldShowGiftQuantitySelector ? (
    <ProductModuleSection {...props}>
      <QuantitySelector
        id="quantity-selector"
        width={1}
        label={localiseText('common.select_quantity')}
        disabled={false}
        quantity={quantity}
        maxQuantity={MAX_GIFT_QUANTITY}
        onQuantityChange={(newQuantity: number) => {
          dispatch({
            type: ProductDetailsStateActionTypes.SET_QUANTITY,
            payload: newQuantity,
          })

          trackGAEvent(
            createProductQuantitySelectorSelectContentGAEvent({
              productId: id,
              quantity: newQuantity,
              masterVariantTitle: masterVariant.title,
            }),
          )
        }}
      />
    </ProductModuleSection>
  ) : null
}
